import type { RouteRecordRaw } from 'vue-router'
import { $t } from '@/locales'

function Layout() {
  return import('@/layouts/index.vue')
}

const ItemLibrary: RouteRecordRaw = {
  path: '/new_media_library',
  name: 'newMediaLibrary',
  meta: {
    title: $t('route.new_media.library'),
    icon: 'i-heroicons-solid:menu-alt-3',
  },
  component: () => import('@/views/new_media/library.vue'),
}

const ItemLibrary2: RouteRecordRaw = {
  path: '/video_comments',
  name: 'videoComments',
  meta: {
    title: $t('route.video_comments.title'),
    icon: 'i-heroicons-solid:menu-alt-3',
  },
  component: () => import('@/views/video_comments/library.vue'),
}

const routes: RouteRecordRaw = {
  path: '/new_media',
  component: Layout,
  name: 'newMediaRoute',
  meta: {
    title: $t('route.new_media.tools'),
    icon: 'i-heroicons-solid:menu-alt-3',
    alwaysOpened: true,
  },
  children: [
    ItemLibrary,
    ItemLibrary2,

  ],
}
export default routes
